import React from 'react';
import { useEffect } from 'react';

import errormsg from './../assets/fillerIllus02.png'
import decor from './../assets/pagedecor.svg'
import './error.css'
import HeadingBlock from '../components/common/heading';
import BlinkingEye from '../components/common/blinkingEye';
import Button from '../components/common/button';
import Header from '../components/layout/header';
// import Preloader from '../components/layout/preloader';

const Error = () => {
      useEffect(() => {
        const originalColor = window.getComputedStyle(document.body).backgroundColor;
        document.body.style.setProperty('background-color', '#FFF4E2', 'important');
    
        return () => {
          document.body.style.removeProperty('background-color');
          document.body.style.backgroundColor = originalColor;
        };
      }, []);
    
    return ( <>
    <Header heading="Vendors" />
    <main className='fixedWidth'>
        <section className='sectionPadded'>
            <div className="errormsg">
                <BlinkingEye />
            <img src={errormsg} alt="" />
            </div>
            <h3 className='center'>
    Sorry, no current vendors are available. Please check back later for updates on upcoming events and activities.
</h3>
                <Button
                style1="blue size1"
                cta=" Back home"
                link="/home"
                />

        </section>
    </main>
    </> );
}
 
export default Error;